import { IExpressionEvaluator, IHasExpressionMetadata } from "../../../Models/IExpressionEvaluator";
import { MaybePromise } from "../../../Models/MaybePromise";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";
import { OrExpression } from "../../../Models/Logical/OrExpression";

export class OrExpressionEvaluator implements IExpressionEvaluator<OrExpression>, IHasExpressionMetadata {
  get type(): string {
    return "Or";
  }

  private static _expressionPropertyNames: string[] = ["Value"];

  get expressionProperties(): string[] {
    return OrExpressionEvaluator._expressionPropertyNames;
  }

  // Evaluates values in order and returns the first truthy value (short-circuit OR logic).
  // If all values are falsy, returns the last evaluated value.
  evaluate(expression: OrExpression, context: IExpressionEvaluatorContext): MaybePromise {
    let result = undefined;
    for (let i = 0; i < expression.Value.length; i++) {
      result = context.Evaluator.evaluate(expression.Value[i], context);

      // If we got a promise, we need to switch to async
      if (result instanceof Promise) {
        return result.then((resolvedResult) => {
          if (!!resolvedResult) {
            return resolvedResult;
          }
          // Continue with remaining expressions asynchronously
          return this.evaluateRemainingAsync(expression.Value, i + 1, context);
        });
      }

      // Short-circuit: if truthy, return immediately
      if (!!result) {
        return result;
      }
    }
    return result;
  }

  private async evaluateRemainingAsync(values: any[], startIndex: number, context: IExpressionEvaluatorContext): Promise<any> {
    let result = undefined;
    for (let i = startIndex; i < values.length; i++) {
      result = await context.Evaluator.evaluate(values[i], context);
      if (!!result) {
        return result;
      }
    }
    return result;
  }
}
